const ITEMS = [
  "15+ Years of Service",
  "GSTIN 33AINPR0146B1ZM",
  "Mfrs. of Krithish Lab Equipments",
  "Laboratory · Research · Educational · Medical",
  "Repairing & Servicing Undertaken",
  "Chemical & Glass Wares Supplied",
];

export default function Marquee() {
  return (
    <section aria-label="Certifications and highlights" className="overflow-hidden border-b border-white/10 bg-navy">
      <div className="flex w-max animate-marquee items-center py-4">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span
            key={i}
            aria-hidden={i >= ITEMS.length}
            className="flex items-center gap-8 pr-8 font-mono text-[11px] uppercase tracking-[0.3em] text-rose-300/90"
          >
            {t}
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-amber-400" aria-hidden="true" />
          </span>
        ))}
      </div>
    </section>
  );
}
